<template>
  <div>
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="float-right">
          <button class="mr-3 btn btn-light btn-sm" @click="slide('previous')">
            ❮ Previous
          </button>
          <span class="mr-3">
            {{
              (current_index + 1) + " / " + slider_items.length
            }}
          </span>
          <button
            class="navigate-btn btn btn-light btn-sm"
            @click="slide('next')"
          >
            Next ❯
          </button>
        </div>
      </div>
    </div>
    <div class="ns-slider mt-3">
      <div class="ns-slider-content" v-for="file in files" :key="file.id">
        <img
          v-if="file.file_type.includes('image')"
          :src="getMediaItemLink(file.file_path, file.storage_disk)"
          class="slider-element"
        />
        <video
          v-else-if="file.file_type.includes('video')"
          controls
          class="slider-element"
          preload="metadata"
          controlsList="nodownload"
          oncontextmenu="return false;"
        >
          <source
            :src="getMediaItemLink(file.file_path, file.storage_disk)"
            :type="file.file_type"
          />
          Your browser does not support the video tag.
        </video>
        <audio
          v-else-if="file.file_type.includes('audio')"
          controls
          controlsList="nodownload"
          oncontextmenu="return false;"
          style="margin-top: 100px"
        >
          <source
            :src="getMediaItemLink(file.file_path, file.storage_disk)"
            :type="file.file_type"
          />
          Your browser does not support the audio element.
        </audio>
        <img v-else class="slider-element" src="/images/files.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
export default {
  setup() {
    onMounted(() => {
      const items = document.getElementsByClassName("ns-slider-content");
      if (items.length > 0) {
        items[0].style.display = "block";
      }
    });
  },
  props: {
    files: Object,
  },
  mounted() {
    this.slider_items = document.getElementsByClassName("ns-slider-content");
  },
  data() {
    return {
      current_index: 0,
      slider_items: [],
    };
  },
  methods: {
    slide(direction) {
      [...this.slider_items].forEach((element) => {
        element.style.display = "none";
      });

      let newIndex =
        direction == "next" ? this.current_index + 1 : this.current_index - 1;

      if (newIndex > this.slider_items.length - 1) {
        newIndex = 0;
      } else if (newIndex < 0) {
        newIndex = this.slider_items.length - 1;
      }

      // this.current_index += direction == "next" ? +1 : -1;
      this.current_index = newIndex;

      if (this.slider_items[this.current_index]) {
        this.slider_items[this.current_index].style.display = "block";
      }
    },
  },
};
</script>